import store from '@/store'

const baseUrl = 'https://beta.paineldocorretor.com.br'

export function redirectToBeta () {
    if (process.env.VUE_APP_ENV !== 'production')
        return

    redirectUrl()
}

function redirectUrl () {
    const redirect = map.find(p => location.pathname.match(p.pattern))

    if (!redirect || location.search.includes('skipBeta'))
        return

    let path = redirect.to

    if (path.includes('$')) {
        const source = location.pathname + location.search
        path = source.replace(redirect.pattern, redirect.to)
    }

    const { tenant, accessToken } = store.state.auth
    const url = new URL(path)
    url.searchParams.set('token', accessToken)
    url.searchParams.set('tenant', tenant)

    location.replace(url.href)
}

const map = [
    {
        pattern: /^\/produtos(\/?)/,
        to: `${baseUrl}/produtos`
    },
    {
        pattern: /^\/cotacoes(\/?)$/,
        to: `${baseUrl}/cotacoes?periodo=30`
    },
    {
        pattern: /^\/cotacoes\/nova(.*)$/,
        to: `${baseUrl}/cotacoes/nova$1`
    },
    {
        pattern: /^\/cotacoes\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/,
        to: `${baseUrl}/cotacoes/$1/edit`
    },
    {
        pattern: /^\/conta\/cadastrar(.*)$/,
        to: `${baseUrl}/conta/cadastrar$1`
    },
]